import {LOGO_URL} from "../../conf";

export interface LogoProps {
    width?: any;
    height?: any;
    onClick?: any;
}

const Logo = ({width, height, onClick}: LogoProps) => {
    return (
        <div onClick={onClick} className={'flex flex-row items-center'}>
            <img src={LOGO_URL} className={'rounded-md'}
                 width={width} height={height} alt="Logo"/>
        </div>
    );
}

export default Logo;
